import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { isMobileDevice } from '@superbet-group/web.lib.vue-utilities';

import { defaultHttpTimeoutMs } from '@core/constants';
import {
    SeonSession,
    TransactionChannel,
    TransactionMethod,
} from '@core/services/antiFraud/types';
import { TransactionType } from '@superbet-group/web.types';

interface Config {
    host: string;
}

export default class RestService {
    private readonly restClient: RestClient;

    constructor(config: Config) {
        this.restClient = createRestClient(config.host, defaultHttpTimeoutMs, true);
    }

    public sendTransaction(
        method: TransactionMethod,
        transactionType: TransactionType,
        transactionData: Record<string, unknown> | undefined,
        seonSession: SeonSession,
    ): Promise<{ error: boolean; country: string }> {
        const channel: TransactionChannel
            = isMobileDevice() ? TransactionChannel.Mobile : TransactionChannel.Desktop;

        return this.restClient.post('/user/sendAntiFraudAction', {
            seon_session: seonSession,
            channel,
            method,
            transactionType,
            transactionData,
        });
    }
}
